require("./sdk/sdk");

import Alpine from "alpinejs";
import serialize from "./libs/serialize";
import debounce from "./utils/debounce";
import detectBreakpoint from "./utils/detect-breakpoint";
import detectTouch from "./utils/detect-touch";
import escape from "./utils/escape";
import file from "./utils/file";
import handleize from "./utils/handleize";
import money from "./utils/money";
import "./components/product-recommendations";
import "./components/collection-slider";

//
//  Utils
//  _____________________________________________

debounce.init();
money.init();
detectBreakpoint.init();
detectTouch.init();
escape.init();
file.init();
handleize.init();
money.init();

//
//  Libs
//  _____________________________________________

serialize.init();
require("./libs/tabbable");
require("./libs/focus-trap");

//
//  Web components
//  _____________________________________________

require("./components/side-drawer");
require("./components/component-accordion");
require("./components/variant-selector");
require("./components/product-price");
require("./components/component-swatches");
require("./components/quantity-selector");
require("./components/addtocart-button");
require("./components/component-addtocart");
require("./components/swiper-slider");
require("./components/product-card");
require("./components/minicart-item");
require("./components/component-minicart");
require("./components/tooltip");
require("./components/menu");
require("./components/search-bar");
require("./components/predictive-search");
require("./components/page-login");
require("./components/view-password");
require("./components/page-register");
require("./components/product-media");
require("./components/sort-by");
require("./components/cart-table");
require("./components/popup-modal");
require("./components/tab");
require("./components/wishlist-icon");
require("./components/free-shipping");
require("./components/page-account");
require("./components/page-address");
require("./components/collection-filters");
require("./components/filters");
require("./components/recently-viewed");
require("./components/component-pickup-availability");
require("./components/share-wishlist");
require("./components/load-more");
require("./components/price-quantity");
require("./components/cart-item-price");
require("./components/cart-total-price");
require("./components/modal-dialog");
require("./components/modal-opener");
require("./components/component-label-customization");
require("./components/tooltip-pricing-table");
require("./components/cart-compatible-products");

// Alpine.js
window.Alpine = Alpine;
Alpine.start();
